// Add entries keyed by product id. If an id exists here, ApiInfo renders this
// local rich content instead of only DB description.
const localApiRichContent = {
  // Product id: 25000 (Webhook)
  25000: {
    title: 'Webhooks',
    blocks: [
      {
        type: 'p',
        parts: [
          { text: 'To utilize the Webhook service, you are required to provide the ' },
          { text: 'test and production URLs', bold: true },
          { text: ' to which we will transmit webhook notifications. Once provided, we will initiate the necessary configuration and definition processes for these URLs within our system.' }
        ]
      },
      {
        type: 'h',
        parts: [
          { text: 'Authentication & Security', bold: true }
        ]
      },
      {
        type: 'p',
        parts: [
          { text: 'We apply an extra security step by signing the requests. In the Signature step, the " ' },
          { text: 'sign', bold: true },
          { text: ' " parameter is transmitted in the header. For signature validation, we will generate a ' },
          { text: 'public-private key', bold: true },
          { text: ' pair and share the ' },
          { text: 'public key', bold: true },
          { text: ' value with you. We will sign the request\'s body with the ' },
          { text: 'secret key', bold: true },
          { text: '. We expect you to verify the body signed with the public key we transmitted to you.' }
        ]
      },
      {
        type: 'p',
        parts: [
          { text: 'Example Webhook Format (JSON):', bold: true }
        ]
      },
      {
        type: 'json',
        value: `{
  "ProcessDate": "01.03.2024 16:36",
  "SenderAccount": "T*****************1",
  "SenderNameInfo": "A************v",
  "ReceiverAccount": "T****************2",
  "ReceiverNameInfo": "O***************Ş",
  "Amount": "3.700,00",
  "CurrencyCode": "TRY",
  "Description": "",
  "TransactionCode": "CVIRM",
  "TransactionId": "221020251372"
}`
      },
    {
        type: 'h',
        parts: [
          { text: 'Platform Setup & Configuration', bold: true },
        ]
      },
      {
        type: 'p',
        parts: [
          { text: ' In addition to these steps, you must ' },
          { text: 'register', bold: true },
          { text: ' on the Albaraka API Market (' },
          { text: 'Albaraka Api Market', link: 'https://developer.albarakaturk.com.tr/register' },
          { text: '), create a test application, and activate the webhook section within that application.' }
        ]
      },
      {
        type: 'list',
        items: [
          {
            parts: [
              { text: 'Client ID/Secret:', bold: true },
              { text: ' A client ID and client secret value will be automatically assigned to you in the test environment you created. You need to forward your ' },
              { text: 'client ID', bold: true },
              { text: ' value to us.' }
            ]
          },
          {
            parts: [
              { text: 'Customer Definition:', bold: true },
              { text: ' After you share the client information, our technical team will complete the webhook definition in the test environment, designating one of the test environment customers as your customer.' }
            ]
          },
          {
            parts: [
              { text: 'Subscription:', bold: true },
              { text: ' Afterwards, for the transaction types you wish to receive webhook notifications for, you need to create a registration by calling the ' },
              { text: 'save webhook', bold: true },
              { text: ' service under the ' },
              { text: 'webhooks scope', bold: true },
              { text: ' on the developer portal (' },
              { text: 'https://developer.albarakaturk.com.tr/docs', link: 'https://developer.albarakaturk.com.tr/docs' },
              { text: ').' }
            ]
          },
          {
            parts: [
              { text: 'Transaction Codes:', bold: true },
              { text: ' You can make a service call by providing the transaction type you want to receive notifications for in the trancode field of the relevant service request. The basic transaction types are as follows:' }
            ],
            subItems: [
              { parts: [{ text: 'CHVLH // Incoming Remittance (Wire Transfer)' }] },
              { parts: [{ text: 'EEFTO // Incoming EFT / EFT Refund' }] },
              { parts: [{ text: 'FBTCH // Incoming FAST' }] },
              { parts: [{ text: 'EMEGI // Outgoing EFT' }] },
              { parts: [{ text: 'FMEGI // Outgoing FAST / FAST Refund' }] }
            ]
          }
        ]
      },
      {
        type: 'p',
        parts: [
          { text: 'Note:', bold: true },
          { text: ' If you provide us with the codes you request, we can also perform this definition for you.' }
        ]
      },
      {
        type: 'h',
        parts: [
          { text: 'Testing & Production', bold: true }
        ]
      },
      {
        type: 'list',
        items: [
          {
            parts: [
              { text: 'Once you have created the records, a webhook/notification will be sent to the test URL you shared with us whenever any movement occurs towards the accounts of the customer defined as your customer in the test environment for the relevant transaction types.' }
            ]
          },
          {
            parts: [
              { text: 'After completing the test process, we will proceed in the same way for the production integration.' }
            ]
          }
        ]
      }
    ],
    image: '/static/images/webhooks.jpg',
    imageAlt: 'Webhook onboarding and transition flow'
  }
};

export default localApiRichContent;